import React from "react";

export default function PreloaderListItem() {
  return (
    <div className="pre-list-item">
      <div className="pre-list-item-icon shine"></div>
      <div className="pre-list-item-content shine"></div>
    </div>
  );
}
